import emptySliceApi from '../../../shared/store/emptyApiSlice';
import AccountDto from '../../../shared/models/AccountModel';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadLogo: builder.mutation<
      AccountDto,
      { accountId: string; payload: FormData }
    >({
      query: ({ accountId, payload }) => ({
        url: `v4/accounts/${accountId}/logo`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['AccountData'],
    }),

    removeLogo: builder.mutation({
      query: (accountId) => ({
        url: `v4/accounts/${accountId}/logo`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AccountData'],
    }),
  }),
});

export const { useUploadLogoMutation, useRemoveLogoMutation } = apiSlice;
